import { Box, Typography } from '@mui/material';

const Title = ({ title, disableMargin, center, rightButton }) => (
  <Box
    display="flex"
    alignItems="center"
    mt={!disableMargin ? 3 : 0}
    justifyContent={center ? 'center' : 'space-between'}
  >
    <Typography variant="h5" fontWeight="bold">
      {title}
    </Typography>
    {!center && rightButton}
  </Box>
);

export default Title;
